import { notification, message } from "antd";

const INACTIVE_PATIENT_PATTERNS = [
  "inactive patient",
  "not active",
  "deactivated",
  "cannot enroll an inactive",
  "cannot create a prescription for an inactive",
  "cannot bill for an inactive",
  "cannot create an examination for an inactive",
];

function pickErrorDetail(err) {
  const data = err?.response?.data;
  if (!data) return "";
  if (typeof data === "string") return data;
  if (typeof data.detail === "string") return data.detail;
  for (const v of Object.values(data)) {
    if (typeof v === "string") return v;
    if (Array.isArray(v) && typeof v[0] === "string") return v[0];
  }
  return "";
}

function looksInactive(detail) {
  if (!detail) return false;
  const lower = detail.toLowerCase();
  return INACTIVE_PATIENT_PATTERNS.some((p) => lower.includes(p));
}

export function showInactivePatientNotice() {
  notification.error({
    message: "Patient Inactive",
    description:
      "This patient account is not active. Please reactivate through Administration before issuing prescriptions.",
    duration: 6,
  });
}

/**
 * Shows a user-friendly notification when an API call fails. Handles the
 * inactive-patient special case, specific HTTP status codes, and network errors.
 *
 * Returns `true` if the inactive-patient path was taken — callers can use
 * this to skip any further error toasts they would otherwise render.
 */
export function handleApiError(err, fallback) {
  // Network error — no response at all
  if (!err?.response) {
    message.error("Unable to connect to the MCHUSA server. Please check your internet connection or contact support at info@mchusa.com");
    return false;
  }

  const detail = pickErrorDetail(err);

  // Inactive patient takes priority over generic status-code handling
  if (looksInactive(detail)) {
    showInactivePatientNotice();
    return true;
  }

  const { status } = err.response;

  if (status === 401) {
    message.error("Your session has expired. Please log in again.");
    return false;
  }
  if (status === 403) {
    message.error("You don't have permission to perform this action. Contact your system administrator if you believe this is an error.");
    return false;
  }
  if (status === 500) {
    message.error("An unexpected server error occurred. Our team has been notified. Please try again in a few minutes.");
    return false;
  }

  const text = detail || fallback || "Something went wrong. Please try again.";
  message.error(text);
  return false;
}
